export const aiPersonality = {
  //  List Page
  listTitle: 'AI語音人格生成器',
  listSubtitle: '管理您的 AI 語音人格模板',
  addPersonality: '+ 新增人格',
  personaName: '人格名稱',
  companyName: '公司名稱',
  gender: 'AI 性別',
  personality: 'AI 個性',
  voiceSource: '聲音來源',
  llmModel: '大模型',
  updatedAt: '更新時間',
  actions: '操作',
  edit: '編輯',
  copy: '複製',
  delete: '刪除',
  noData: '尚無人格模板，請點擊「+ 新增人格」建立',
  
  //  Form Page
  title: 'AI語音人格生成器',
  subtitle: '建立與管理 AI 業務員或客服人格模板',
  backToList: '返回列表',
  createTitle: '新增人格',
  editTitle: '編輯人格',
  
  //  Basic Info
  basicInfo: '基本資料',
  aiName: 'AI 姓名',
  aiNamePlaceholder: '例如：小美',
  aiCompany: 'AI 公司名稱',
  aiCompanyPlaceholder: '例如：信義房屋',
  
  //  Gender & Personality
  genderPersonality: '性別與個性',
  enthusiastic: '熱情',
  confident: '自信',
  professional: '專業',
  humorous: '幽默',
  
  //  Voice Settings
  voiceSettings: 'AI 聲音設定',
  anchorVoice: '主播聲音',
  cloneVoice: '克隆聲音',
  uploadRecording: '上傳錄音檔',
  uploadHint: '建議錄音長度：約 20 秒',
  supportedFormats: '支援格式：MP3 / WAV / M4A',
  fileSizeLimit: '檔案大小限制：10MB',
  recordingTips: '建議：安靜環境、單人清晰朗讀',
  dragDropHint: '拖曳檔案至此或點擊上傳',
  uploading: '上傳中...',
  uploadSuccess: '上傳成功',
  fileName: '檔案名稱',
  duration: '時長',
  changeFile: '更換檔案',
  removeFile: '移除',
  volume: '音量',
  speed: '語速',
  tone: '語調',
  
  //  Knowledge Base
  knowledgeBase: '知識庫模板設定',
  development: '開發',
  negotiation: '議價',
  sales: '銷售',
  report: '回報',
  supplement: '補充說明',
  default: '默認',
  custom: '自定義',
  
  //  LLM Model
  llmSettings: '大模型設定',
  llmModelLabel: '選擇使用的大型語言模型',
  
  //  Actions
  incomplete: '未完成',
  savePersonality: '儲存 AI 人格',
  saveSuccess: 'AI 人格已儲存成功！',
  deleteConfirm: '確定要刪除此人格嗎？',
  copySuccess: '人格已複製成功！',
};
